import { ActionContext } from 'vuex';

import { ActionFunction, commit } from '@/store/store-helper';

import {
  getLastSearchPosition,
  getSearchCriteria,
  getSearchResult,
  SEARCH_LIMIT,
  SearchResult,
} from './helpers/search-helper';
import { SearchState } from './search-state';

type ActionSearchPayload = {
  isInitial?: boolean;
  limit?: number;
};

declare module '@/store/store-helper' {
  interface Action {
    actionSearch: ActionFunction<ActionSearchPayload, SearchResult>;
  }
}

export async function actionSearch(
  { state }: ActionContext<SearchState, unknown>,
  { limit = SEARCH_LIMIT, isInitial = true }: ActionSearchPayload,
): Promise<SearchResult> {
  let position = '';
  if (!isInitial) {
    position = getLastSearchPosition(state.profiles);
  }

  const result = await getSearchResult(position, getSearchCriteria(state.filter), limit);

  commit('mutationSearchAddProfiles', result.profiles);
  commit('mutationSearchSetFilter', result.filter);

  return result;
}
